import React, {useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getCompliance } from 'redux/actions/UserCompliance';
import { useNavigate, useParams } from 'react-router-dom';
import CommonBreadCrumb from "components/commonBreadCrumb/CommonBreadCrumb";
import ComplianceTab from "./ComplianceTab";
import Loader from 'components/loader/Loader';
import { Grid } from '@mui/material';
import CommonDateRangePicker from 'pages/date/CommonDateRangePicker';
import CommonFilter from 'components/commonFilter/CommonFilter';
import { complianceFilterData } from './ComplianceDocumentData';
import moment from 'moment';
import { debounce } from 'lodash';


function ComplianceTable() {
  const complianceStatus = JSON.parse(localStorage.getItem('complianceStatus'))
  const {tabs} = useParams();
  const navigate = useNavigate();
  const tableData = useSelector((state) => state?.userCompliance?.userCompliance?.data);
  const loader = useSelector((state) => state?.userCompliance?.loading);
  const dispatch = useDispatch();
  const [type, setType] =useState(localStorage.getItem('role') === 'subVendorCompany' ? 'Driver' : 'SubVendor')
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [status, setStatus] = useState(complianceStatus?.length > 0 ? complianceStatus : "");
  const [value, setValue] = useState(tabs ? tabs : '2'); // value 1 for admin ---vendorCompany
  const [registration, setRegistration] = useState('subVendorRegistration')
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  let filterData = {
    type: registration,
    id:'',
    page:page,
    dateFrom:dateFrom,
    dateTo:dateTo,
    status:status,
    pageSize:rowsPerPage,
    search: search
  };

	useEffect(() => {
    const role = localStorage.getItem('role');
    // Check if the role is 'vendor' or 'vendorCompany' and set default value accordingly
    if (role === 'vendorCompany') {
      setValue('2');
      setType('SubVendor');
      setRegistration('subVendorRegistration')
      filterData= {...filterData,type:'subVendorRegistration'}
    }else if(role ==='subVendorCompany'){
      setValue('3');
      setType('Driver');
      setRegistration('driverRegistration')
      filterData= {...filterData,type:'driverRegistration'}
    } else {
      //For Vendor in Admin ---vendorCompany
      // setValue('1');
      // setType('Vendor');
      setValue('2');
      setType('SubVendor');
      setRegistration('subVendorRegistration')
    }

    // Added condition for breadcrumb navigation
    // dispatch(getCompliance(filterData));
    setValue(tabs)
    // setStatus([]);
    setPage(0);
    if(tabs == 2){
      setType('SubVendor')
      setRegistration('subVendorRegistration')
      filterData= {...filterData,type:'subVendorRegistration', page: 0}
      dispatch(getCompliance(filterData))
    }else if(tabs == 3){
      setType('Driver')
      setRegistration('driverRegistration')
      filterData= {...filterData,type:'driverRegistration', page: 0}
      dispatch(getCompliance(filterData))
    }else if(tabs == '4'){
      setType('Vehicle')
      setRegistration('vehicleRegistration')
      filterData= {...filterData,type:'vehicleRegistration', page: 0}
      dispatch(getCompliance(filterData))
    }else if(tabs == '5'){
      setSearch([])
    }
  }, []);

  const onTabChange = (value) => {
    localStorage.removeItem('complianceStatus')
    navigate(`/compliance/${value}`)
    setValue(value)
    setStatus([]);
    setPage(0);
    if(value == 1){
      setType('Vendor')
      setRegistration('vendorRegistration')
      filterData= {...filterData,type:'vendorRegistration',status:"", page: 0}
      dispatch(getCompliance(filterData))
    }else if(value == 2){
      setType('SubVendor')
      setRegistration('subVendorRegistration')
      filterData= {...filterData,type:'subVendorRegistration', status:"", page: 0}
      dispatch(getCompliance(filterData))
    }else if(value == 3){
      setType('Driver')
      setRegistration('driverRegistration')
      filterData= {...filterData,type:'driverRegistration',status:"", page: 0}
      dispatch(getCompliance(filterData))
    }else if(value == '4'){
      setType('Vehicle')
      setRegistration('vehicleRegistration')
      filterData= {...filterData,type:'vehicleRegistration',status:"", page: 0}
      dispatch(getCompliance(filterData))
    }else if(value == '5'){
      setSearch([])
    }
  }

  const onClickTableCompliance = (val) => {
    localStorage.setItem('complianceStatus', JSON.stringify(status))
    const vehicleType = val?.vehicleType ? val?.vehicleType : ""
    // navigate(`/compliance/documents?id=${val.id}&status=${val.status}&name=${val.submitterName}&type=${type}&submitterId=${val?.submitterId}&vehicleType=${val?.vehicleType ? val?.vehicleType : ''}`);
    navigate(`/compliance/documents`, {state: {id: val?.id, status: val?.status, name: val?.submitterName, type,submitterId: val?.submitterId, vehicleType }});
  };

  const breadcrumbPaths = [
  ];

  const onFilterChange = (val) => {
    localStorage.removeItem('complianceStatus')
    setStatus(val);
    setPage(0);
    filterData = {...filterData, status:val.toString(), page: 0}
    dispatch(getCompliance(filterData));
  }

   const onRestFilter = () => {
    localStorage.removeItem('complianceStatus')
    setStatus("")
    filterData = {...filterData, status:""}
    dispatch(getCompliance(filterData));
  }

  const onSelectDateRange = (newValue) => {
    setDateFrom(moment(newValue[0]).format("DD-MM-YYYY"))
    setDateTo(moment(newValue[1]).format("DD-MM-YYYY"))
    filterData = {...filterData, 
      dateFrom:moment(newValue[0]).format("DD-MM-YYYY"),
      dateTo:moment(newValue[1]).format("DD-MM-YYYY")
    }
    dispatch(getCompliance(filterData));
  }

  const handleChangePage = (event,newPage) =>{
    setPage(newPage)
    dispatch(getCompliance({...filterData, page:newPage}))
  }

  const handleChangeRowsPerPage = (event) =>{
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(getCompliance({...filterData, page:0, pageSize:parseInt(event.target.value)}))
  }

  const onSearch = debounce((e) =>{
    setSearch(e)
    const searchFilterData = {
     ...filterData,search:e, page: 0
    }
    dispatch((getCompliance(searchFilterData)))
   },1000)

  return (

    <div className='paddingTopBottom10'>
      {/* <Grid container direction='row' justifyContent='space-around' alignItems='center'>
        <Grid item sm={6}><CommonBreadCrumb paths={breadcrumbPaths} /></Grid>
        <Grid item container direction='row' justifyContent='flex-end' alignItems='center' sm={6}>
          <Grid item > <CommonDateRangePicker onSelectDateRange={onSelectDateRange}/></Grid>
          <Grid item className='marginLeft20'><CommonFilter filterdata={complianceFilterData} onFilterChange={onFilterChange} /></Grid>
        </Grid>
      </Grid> */}
      
      <ComplianceTab 
        defaultStatus={status}
        className="marginTop" 
        tableData={tableData} 
        onClickTableVendor={onClickTableCompliance} 
        handleChange={onTabChange} 
        value={value}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        page={page}
        rowsPerPage={rowsPerPage} 
        filterdata={complianceFilterData} 
        onFilterChange={onFilterChange}
        onRestFilter={onRestFilter}
        onSearch={onSearch}
        loader={loader}
      />
    </div>
  )
}
export default ComplianceTable;